import React, { useState, useRef } from 'react';
import { View, Text, ScrollView, Dimensions, Animated, Platform } from 'react-native';
import { VERIFY_DETAILS, VERIFY_ID, CARD, BOOKING_DETAILS } from '../../assets';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import PaginationDots from '../../components/paginationDots/paginationDots';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { isWeb } from '../../utils/Helper';

const { width: screenWidth } = Dimensions.get('window');

const CheckInGuide = (props) => {
  const {
    idValidationEnabled,
    accompanyGuestImagesFlowEnabled,
    cardValidationEnabled,
    accompanyGuestFlowEnabled,
    handleGoBack,
    handleCancel,
    handleNextPage,
  } = props || {};

  const [parentWidth, setParentWidth] = useState(screenWidth);


  const [activeIndex, setActiveIndex] = useState(0);
  const scrollX = useRef(new Animated.Value(0)).current;
  const scrollViewRef = useRef(null);
  const debounceTimeout = useRef(null);


  const { t } = useTranslation();
  const getStyles = useCssStyle();

  const slides = [
    {
      image: VERIFY_DETAILS,
      title: t('check_in.checkin_guide.booking_info_heading'),
      description: t('check_in.bookingInfo.checkin_note'),
    },
    ...(idValidationEnabled ? [{
      image: VERIFY_ID,
      title: t('check_in.checkin_guide.id_verification_heading'),
      description: t('check_in.checkin_guide.id_verification_subheading'),
    }] : []),
    ...(accompanyGuestImagesFlowEnabled ? [{
      image: VERIFY_ID,
      title: t('check_in.checkin_guide.companion_id_heading'),
      description: t('check_in.checkin_guide.companion_id_subheading'),
    }] : []),
    ...(cardValidationEnabled ? [{
      image: CARD,
      title: t('check_in.checkin_guide.card_verification_heading'),
      description: t('check_in.checkin_guide.card_verification_subheading'),
    }] : []),
    {
      image: BOOKING_DETAILS,
      title: t('check_in.checkin_guide.additional_details_heading'),
      description: t('check_in.checkin_guide.additional_details_subheading'),
    },
    ...(accompanyGuestFlowEnabled ? [{
      image: BOOKING_DETAILS,
      title: t('check_in.checkin_guide.companion_details_heading'),
      description: t('check_in.checkin_guide.companion_details_subheading'),
    }] : []),
  ];

  const handleNavigation = (direction) => {
    const newIndex = activeIndex + direction;
    if (newIndex >= 0 && newIndex < slides.length) {
      scrollViewRef.current?.scrollTo({
        x: newIndex * parentWidth,
        animated: true,
      });
      setActiveIndex(newIndex);
    }
  };

  const handleScroll = (event) => {
    const offsetX = event.nativeEvent.contentOffset.x;
    clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      const index = Math.round(offsetX / parentWidth);
      setActiveIndex(index);
    }, 100);
  };

  return (
    <View style={getStyles(['widgetRootContainer', 'checkInGuideRootContainer'])}
      onLayout={(event) => {
        const { width } = event.nativeEvent.layout;
        setParentWidth(width);
      }}>
      <HeaderWithBack handleCustomBackPress={handleGoBack} handleCustomCancelClick={handleCancel} />


      <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['widgetmainContainer','checkInGuideMainContainer'])}
        onLayout={(event) => {
          const { width } = event.nativeEvent.layout;
          setParentWidth(width);
        }}
      >
        <Animated.ScrollView
          ref={scrollViewRef}
          horizontal
          pagingEnabled
          showsHorizontalScrollIndicator={false}
          onScroll={Animated.event(
            [{ nativeEvent: { contentOffset: { x: scrollX } } }],
            { useNativeDriver: false, listener: handleScroll }
          )}
          scrollEventThrottle={16}
          style={{ flexGrow:0 }}
        >
          {slides.map((slide, index) => (
            <View key={index} style={getStyles(['widgetmainContainerHeaderContainer', 'checkInGuideMainContainerHeaderContainer', { width: parentWidth }])}>
              <ImageComp source={slide.image} style={getStyles(['widgetmainContainerHeaderImg', 'checkInGuideMainContainerHeaderImg'])} />

              <View style={[getStyles(['widgetmainContainerHeaderTitleContainer', 'checkInGuideMainContainerHeaderTitleContainer'])]}>
                <Text style={getStyles(['widgetmainContainerHeaderTitle', 'checkInGuideMainContainerHeaderTitle'])}>{slide.title}</Text>
                <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'checkInGuideMainContainerHeaderSubTitle'])}>{slide.description}</Text>
              </View>
            </View>
          ))}
        </Animated.ScrollView>


        <View style={getStyles(['widgetmainContainerChildContainer', 'checkInGuideMainContainerChildContainer'])}>

          <View style={getStyles(['checkInGuideButtonContainer'])}>

            {activeIndex < slides.length - 1 ? (
              <CustomPressable
                style={getStyles(['primaryBtn'])}
                onPress={() => handleNavigation(1)}
              >
                <Text style={getStyles(['primaryBtnTxt'])}>
                  {t('check_in.next')}
                </Text>
              </CustomPressable>
            ) : (
              <CustomPressable
                style={getStyles(['primaryBtn'])}
                onPress={handleNextPage}
              >
                <Text style={getStyles(['primaryBtnTxt'])}>
                  {t('check_in.lets_check_in')}
                </Text>
              </CustomPressable>
            )}

            {activeIndex < slides.length - 1 &&
              <CustomPressable
                style={getStyles(['secondaryBtn'])}
                onPress={handleNextPage}
              >
                <Text style={getStyles(['secondaryBtnTxt'])}>
                  {t('check_in.skip_intro')}
                </Text>
              </CustomPressable>
            }

          </View>


          <PaginationDots
            totalDots={slides.length}
            activeIndex={activeIndex}
            animatedValue={scrollX}
          />

        </View>

      </ScrollView>
    </View>
  );
};

export default React.memo(CheckInGuide);
